import axios from 'axios';
import { error } from '../common/helpers/toastify';
export const graphqlPost = function (querystring = "", url = 'Inventory/graphql') {
  return new Promise(async (resolve, reject) => {
    var data = JSON.stringify({
      query: querystring,
      variables: {}
    });
    var config = {
      method: 'post',
      url: process.env.REACT_APP_API_URL + 'api/v1/' + url,
      headers: {
        'authorization': localStorage.getItem("UserToken"),
        'Content-Type': 'application/json'
      },
      data: data
    };



    await axios(config)
      .then(function (response) {
        if (response?.data?.code === 403) {
          localStorage.removeItem("UserToken");
          localStorage.removeItem('updateModulePermission');
          localStorage.removeItem('updateUserPermission');
          var currentPath = window.location.pathname;
          window.location.href = "/login?msg=sessionexpired&history=" + encodeURIComponent(currentPath);
        } else { resolve(response?.data); }
      })
      .catch(function (err) {
        error(err?.message)
      });
  });
};


export const _Api = function (querystring = "", Url = "") {
  return new Promise(async (resolve, reject) => {
    var data = querystring;
    var config = {
      method: 'post',
      url: process.env.REACT_APP_API_URL + Url,
      headers: {
        'authorization': localStorage.getItem("UserToken"),
        'Content-Type': 'application/json'
      },
      data: data
    };
    await axios(config)
      .then(function (response) {
        if (response?.data?.code === 403) {
          localStorage.removeItem("UserToken");
          localStorage.removeItem('updateModulePermission');
          localStorage.removeItem('updateUserPermission');
          var currentPath = window.location.pathname;
          window.location.href = "/login?msg=sessionexpired&history=" + encodeURIComponent(currentPath);
        } else { resolve(response?.data); }
      })
      .catch(function (err) {
        if (err?.response?.data && typeof err.response.data === 'object') {
          resolve(err.response.data);
        } else {
          error(err?.message)
        }
      });
  });
};
export const _PdfApi = function (querystring = "", Url = "") {
  return new Promise(async (resolve, reject) => {
    var data = querystring;
    var config = {
      method: 'post',
      url: process.env.REACT_APP_API_URL + Url,
      headers: {
        'authorization': localStorage.getItem("UserToken"),
        'Content-Type': 'application/json',
        'Accept': 'application/pdf'
      },
      data: data,
      responseType: 'blob'
    };

    await axios(config)
      .then(function (response) {
        if (response?.data?.code === 403) {
          localStorage.removeItem("UserToken");
          localStorage.removeItem('updateModulePermission');
          localStorage.removeItem('updateUserPermission');
          var currentPath = window.location.pathname;
          window.location.href = "/login?msg=sessionexpired&history=" + encodeURIComponent(currentPath);
        } else {
          resolve(response.data); // Return only the blob data
        }
      })
      .catch(function (err) {
        error("Failed to fetch PDF.");
        reject(err);
      });
  });
};

export const _tableHeadAPI = function (querystring = "") {
  return new Promise(async (resolve, reject) => {
    var data = {
      "name": querystring
    }
    var config = {
      method: 'post',
      url: process.env.REACT_APP_API_URL + `api/v1/Inventory/common/getColumnHeads`,
      headers: {
        'authorization': localStorage.getItem("UserToken"),
        'Content-Type': 'application/json'
      },
      data: data
    };
    await axios(config)
      .then(function (response) {
        if (response?.data?.code === 200) {
          resolve(response?.data.data);
        } else if (response?.data?.code === 403) {
          localStorage.removeItem("UserToken");
          localStorage.removeItem('updateModulePermission');
          localStorage.removeItem('updateUserPermission');
          var currentPath = window.location.pathname;
          window.location.href = "/login?msg=sessionexpired&history=" + encodeURIComponent(currentPath);
        } else {
          resolve(false);
        }
      })
      .catch(function (err) {
        error(err?.message)
      });
  });

};

export const _Apiauth = function (querystring = "", Url = "") {
  return new Promise(async (resolve, reject) => {
    var data = querystring;
    var config = {
      method: 'post',
      url: process.env.REACT_APP_API_URL + 'api/v1/' + Url,
      headers: {
        'authorization': localStorage.getItem("UserToken"),
        'Content-Type': 'application/json'
      },
      data: data
    };
    await axios(config)
      .then(function (response) {
        if (response?.data?.code === 403) {
          localStorage.removeItem("UserToken");
          localStorage.removeItem('updateModulePermission');
          localStorage.removeItem('updateUserPermission');
          var currentPath = window.location.pathname;
          window.location.href = "/login?msg=sessionexpired&history=" + encodeURIComponent(currentPath);
        } else {
          resolve(response?.data);
        }
      })
      .catch(function (err) {
        error(err?.message)
      });
  });
};


export const Api_form = function (querystring = "", Url = "") {
  return new Promise(async (resolve, reject) => {
    var data = querystring;
    var config = {
      method: 'post',
      url: process.env.REACT_APP_API_URL + Url,
      headers: {
        'authorization': localStorage.getItem("UserToken"),
        'Content-Type': 'multipart/form-data'
      },
      data: data
    };
    await axios(config)
      .then(function (response) {
        if (response?.data?.code === 403) {
          localStorage.removeItem("UserToken");
          localStorage.removeItem('updateModulePermission');
          localStorage.removeItem('updateUserPermission');
          var currentPath = window.location.pathname;
          window.location.href = "/login?msg=sessionexpired&history=" + encodeURIComponent(currentPath);
        } else { resolve(response?.data); }
      })
      .catch(function (err) {
        // Prefer API body message (e.g. PO not approved) over Axios "status code 400".
        const data = err?.response?.data;
        if (data && typeof data === "object") {
          resolve(data);
          return;
        }
        error(err?.message || "Something went wrong! Please try again.");
        resolve({
          code: 400,
          success: false,
          message: err?.message || "Something went wrong! Please try again.",
        });
      });
  });
};
export const CallApi = function (querystring = "", url = "") {
  return new Promise(async (resolve, reject) => {
    var data = querystring;
    var config = {
      method: 'post',
      url: process.env.REACT_APP_API_URL + 'api/v1/' + url,
      headers: {
        'authorization': localStorage.getItem("UserToken"),
        'Content-Type': 'application/json'
      },
      data: data
    };
    await axios(config)
      .then(function (response) {
        resolve(response?.data);
      })
      .catch(function (err) {
        error(err?.message)
      });
  });
};